<template>
  <div class="container-list">
    <div class="flex">
      <!-- <unitList @select="getUnit" @getFirst="getOne"></unitList> -->
      <unitList
        v-show="!($store.state.user.userInfo.natureId == 2)"
        @select="getUnit"
        @getFirst="getOne"
      ></unitList>
      <div class="flex1">
        <div class="common-page common-head">
          <div class="common-page common-head-title">
            <i class="icon-tr--detailed" style="padding-right: 5px"></i>
            预案列表
          </div>
          <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
      </div>-->
        </div>
        <div class="common-page common-body">
          <div
            class="common-page common-tool-bar"
            style="justify-content: space-between"
          >
            <div class="flex"></div>
            <div class="flex">
              <!-- type:  0 只查看  1 可编辑   page:0 演练 1 灭火 3电子预案-->
              <!-- <router-link
                class="ml20"
                :to="{
                  path: '/plan/plan-add',
                  query: { type: 0, page: 3, c_num: cpNum },
                }"
                v-hasPermi="['plan:drillrecord:add']"
              > -->
              <el-button
                type="primary"
                v-hasPermi="['plan:plan:addOrUpdateInfo']"
                @click="dialogPlan = true"
                >新增预案</el-button
              >
              <!-- </router-link
              > -->
              <div class="ml20" @click="showDia = true">
                <!-- <el-button
                  icon="el-icon-search"
                  type="primary "
                  v-hasPermi="['plan:drillrecord:query']"
                  >查询</el-button
                > -->
              </div>
              <el-button
                icon="el-icon-search"
                type="primary "
                @click="showSearchBtn"
                >查询</el-button
              >
              <el-button
                @click="cancle"
                icon="el-icon-refresh-right"
                type="primary "
                >重置</el-button
              >
            </div>
          </div>
          <div class="common-page common-list">
            <el-table :data="list" class="">
              <el-table-column
                prop="num"
                label="序号"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="drill_name"
                align="center"
                label="预案名称"
              ></el-table-column>
              <el-table-column
                prop="drill_weizhi"
                align="center"
                label="预案分区"
                :filters="filterData"
                :filter-method="filterHandler"
                :filter-multiple="false"
              ></el-table-column>
              <el-table-column
                prop="planTypeStr"
                label="预案等级"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="drill_time"
                label="创建时间"
                align="center"
              ></el-table-column>

              <!-- <el-table-column
            prop="m_rate"
            align="center"
            label="巡查频次"
          ></el-table-column> -->

              <el-table-column
                label="操作"
                align="center"
                width="200px"
                fixed="right"
              >
                <template slot-scope="scope">
                  <router-link
                    :to="{
                      path: '/plan/planEditing',
                      query: {
                        id: scope.row.id,
                        c_num: cpNum,
                        series: scope.row.planType,
                      },
                    }"
                  >
                    <!-- <el-button size="mini" type="primary" v-if="scope.row.drill_summary==0" 
                v-hasPermi="['plan:drillrecord:add']"
                       
                        plain>添加记录</el-button> -->
                    <el-button
                      v-hasPermi="['plan:plan:planManagementInfo']"
                      size="mini"
                      type="success"
                      plain
                      >编辑</el-button
                    >
                  </router-link>

                  <el-popconfirm
                    title="确定删除此项吗？"
                    v-hasPermi="['plan:plan:remove']"
                    class="cursor"
                    @onConfirm="changeStatus(scope.row, 2)"
                    @confirm="changeStatus(scope.row, 2)"
                  >
                    <a slot="reference">
                      <el-button type="danger" size="mini">删除</el-button>
                    </a>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="pageChange"
            :page-size="10"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="查询"
      :visible.sync="showDia"
      :close-on-click-modal="true"
    >
      <el-form ref="form" :model="form" label-width="110px">
        <el-form-item label="名称" prop="login_pass">
          <el-input v-model="form.drill_name"></el-input>
        </el-form-item>
        <el-form-item label="一级分区" prop="user_phone">
          <el-select
            v-model="form.drill_tower"
            placeholder="请选择"
            filterable
            @change="changetower"
          >
            <el-option
              @change="changetower($event, index)"
              v-for="(item, index) in units"
              :key="index"
              :label="item.tower"
              :value="item.tower"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级分区" prop="user_phone">
          <el-select v-model="form.drill_tier" placeholder="请选择" filterable>
            <el-option
              v-for="item in select2"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small"
          >确定</el-button
        >
        <el-button type="info" plain @click="showDia = false" size="small"
          >取消</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogPlan" width="30%">
      <p style="font-size:17px">选择新增预案类型</p>
      <div>
        <el-radio
          v-model="radio"
          :label="1"
          style="display:block;margin-top:15px"
          >一级预案</el-radio
        >
        <p style="color:#4A9DFF">
          一级预案是针对可能发生无人员伤亡或被困，燃烧面积小的普通建筑火灾的预案
        </p>
        <el-radio
          v-model="radio"
          :label="2"
          style="display:block;margin-top:15px"
          >二级预案</el-radio
        >
        <p style="color:#4A9DFF">
          二级预案针对可能发生3人以下伤亡或被困，烂烧面积大的普通建筑火灾，燃烧面积较小的高层建筑、地下建筑、人员密集场所、易燃易爆危险品场所、重要场所等特殊场所火灾的预案
        </p>
        <el-radio
          v-model="radio"
          :label="3"
          style="display:block;margin-top:15px"
          >三级预案</el-radio
        >
        <p style="color:#4A9DFF">
          三级预案是针对可能发生3人以上10
          人以下伤亡或被困，燃烧面小的高层建筑、地下建筑、人员密集场所,易燃易爆危险品场所、重要场所等特殊场所火灾的预案
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogPlan = false">取 消</el-button>
        <el-button type="primary" @click="dialogPlanConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <message
      v-if="$store.state.user.userInfo.natureId == 2"
      :type="selectUuid"
      ref="message"
    />
  </div>
</template>

<script>
import unitList from "@/components/unitList";
import message from "@/components/message.vue";

export default {
  components: {
    unitList,
    message,
  },
  data() {
    return {
      cpNum: "",
      selectUuid: "",
      list: [],
      groups: [],
      params: {
        page: 1,
        drill_tower: "",
        drill_tier: "",
        drill_name: "",
        starttime: "",
        endtime: "",
        drill_status: "2",
        company_num: this.cpNum || this.$store.state.user.company.cCompanyNum,
      },
      form: {
        starttime: "",
        drill_tower: "",
        drill_tier: "",
        drill_name: "",
        drill_status: "2",
      },
      units: [],
      select2: [],
      messForm: {
        type: "",
        addr: "",
        ess: "",
        person: [],
      },
      people: [],
      total: 0, // 总数
      showDia: false, // 查询
      checkAll: false, //选择全部
      showDia1: false, // 下发短信
      searchForm: this.$getForm("safePlace"),
      editData: {},
      remoteFuncs: {},
      dialogPlan: false,
      radio: 0,
    };
  },

  created() {
    // this.getList();
  },

  // components: { unitList },
  methods: {
    deWeight(arr) {
				for (var i = 0; i < arr.length - 1; i++) {
					for (var j = i + 1; j < arr.length; j++) {
						if (arr[i].value == arr[j].value) {
							arr.splice(j, 1);
							j--;
						}
					}
				}
				return arr;
			},
      filterHandler(value, row, column) {
				const property = column["property"];
				return row[property] === value;
			},
    dialogPlanConfirm() {
      if (this.radio == 0) {
        this.$message({
          message: "请先选择预案",
          type: "warning",
        });
        return;
      }
      // path: '/plan/plan-add',
      //             query: { type: 0, page: 3, c_num: cpNum },
      console.log(this.radio, "radio选中");
      this.$router.push({
        path: "/plan/planEditing",
        query: { c_num: this.cpNum, series: this.radio },
      });
      this.dialogPlan = false;
    },
    sendMessage(it) {
      this.selectUuid = it.drill_uuid;
      this.$refs["message"].showDia1 = true;
    },
    getOne(v) {
      this.cpNum = v;
    },
    getUnit(v) {
      this.cpNum = v;
    },
    changetower(val, index) {
      this.units.map((item, index) => {
        if (item.tower === val) {
          this.select2 = item.tierList;
        }
      });
    },
    handleCheckAllChange(val) {
      this.people = val ? this.groups : [];
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.groups.length;
    },
    changeStatus(it) {
      this.$post(`/drill/planRemove/${it.drill_uuid}`).then((res) => {
        this.$message({message: res.msg,type: "success", duration: 700,});
        this.getList();
      });
    },
    cancle() {
      this.params.page = 1;
      this.select2=[]
      this.resetSearch();
      this.getList();
    },

    // 生成二维码
    //  跳转添加
    link() {
      this.$route.push("/plan/drill-add");
    },

    getList() {
      this.$post("/drill/drilllist", this.params).then((res) => {
        console.log(res,1111111);
        this.list = res.data.list;
        this.total = res.data.count;
      });
    },
    getList1() {
      this.$post("/score/maintenancelist", this.params).then((res) => {
        this.list = res.data.list;
        this.count = res.count;
      });
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      this.params = { ...this.params, ...this.form };
      this.getList();
      this.showDia = false;

      //  打印
    },
    resetSearch() {
      this.form = {
        starttime: "",
        drill_tower: "",
        drill_tier: "",
        drill_name: "",
        drill_status: "2",
      };
      this.params = {
        page: 1,
        drill_status: "0",
        drill_tower: "",
        drill_tier: "",
        drill_name: "",
        starttime: "",
        endtime: "",
        drill_status: "2",
        company_num: this.cpNum || this.$store.state.user.company.cCompanyNum,
      };
    },
    showSearchBtn() {
      this.showDia = true;
      
      const companyNum = this.params.company_num;
      this.$get(`/drillplan/planJianzhu/planArea/${companyNum}`).then((res) => {
        this.units = res.data;
      });
    },
    // getOne(val) {
    //   this.params.c_company_num = val;
    //   this.getList()
    // },
    // getUnit(val) {
    //   this.params.c_company_num = val;
    //   this.getList()

    // },
  },
  //   beforeRouteEnter(to, from, next) {
  //           console.log(from)
  //   next(vm => {
  //     if(from.name==='/plan-add'){
  //       vm.getList()
  //     }

  //   });
  // },
  beforeRouteEnter(to, from, next) {
    console.log(from);
    next((vm) => {
      if (from.name === "/planEditing") {
        vm.getList();
      }
    });
  },
computed: {
			filterData() {
				var arr = [];
				this.list.forEach((item) => {
					arr.push({
						text: item.drill_weizhi,
						value: item.drill_weizhi,
					});
				});
				this.deWeight(arr);
				return arr;
			},
		},
  watch: {
    cpNum() {
      this.params.company_num = this.cpNum;
      this.params.page = 1;
      this.$post("/drill/companytowetinfo", {
        c_company_num: this.params.company_num,
      }).then((res) => {
        this.units = res.data.list;
      });
      this.getList();
    },
  },
};
</script>

<style scoped>
.el-dialog .el-dialog__body {
  padding: 0 !important;
}
::v-deep .el-radio__label {
  color: black;
  font-size: 20px;
}
::v-deep .el-radio__inner {
  width: 20px;
  height: 20px;
}
</style>
